import BrowserCheck from './src/BrowserCheck'

export default BrowserCheck


// WEBPACK FOOTER //
// ./~/iexplore/components/browser/index.js